import { InfoCircleBold } from '@aslanpay/portal-common-lib';
import { Flex, Text } from '@chakra-ui/react';

function KybInformationHeader() {
  return (
    <Flex h="56px" px="30px" bgColor="alert.info" align="center">
      <InfoCircleBold boxSize="32px" color="system.info" mr="10px" />
      <Text textStyle="body" color="brand.black">
        Some features are locked as we are currently verifying your company information.
      </Text>
    </Flex>
  );
}

export default KybInformationHeader;
